import { CommonPlayerEventParams } from '../useCommonPlayerEventParams';
import { useTriggerOnPlayerEvent } from '../useTriggerOnPlayerEvent';

export const useTriggerOnBufferingStart = (params: CommonPlayerEventParams) => {
    return useTriggerOnPlayerEvent(params, 'PLAYBACK_BUFFERING_START');
};
